<template>
  <section class="section" v-touch:swipe.right="swipeRightHandler">
    <div class="rating">
      <h2 class="rating__head">Рейтинг участников</h2>
      <ul class="rating__list">
        <li class="rating__item" v-for="(rating, index) in ratings">
          <div class="rating__number">{{ index + 1 }}</div>
          <div class="rating__name">{{ rating.name }}</div>
          <div class="rating__answer">{{ rating.correctQuestion }}/15</div>
        </li>
      </ul>
    </div>
    <div class="btn-group">
      <button class="btn btn--fb" v-on:click='doShare'>Рассказать в Facebook</button>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  data() {
    return {
      fbDescriptionNumber: '',
      fbTest: '123',
    }
  },
  mounted() {
    this.$store.dispatch('loadRating');
  },
  computed: {
    randomNumber() {
      return this.$route.params.randomNumber;
    },
    ...mapState([
      'ratings',
      'shareDescription',
      'shareDescriptionNumber',
    ])
  },
  methods: {
    swipeRightHandler() {
      this.$router.push('/statistics');
    },
    doShare() {
      FB.ui({
      method: 'share',
        hashtag: '#digitotal',
        href: `${process.env.VUE_APP_API_CLIENT_URL}/rating`,
      }, function (response) {
        // Action after response
      });
    },
  },
};
</script>

<style lang="less">
.rating {
  border-radius: 3rem;
  background-color: #02a654;
  box-shadow: 4px 4px 16px 0px rgba(0,0,0,1);
  width: 64rem;
  margin: 1.5rem auto 0;
  padding: 4rem;

  @media (max-width: 1023px) {
    width: 58rem;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 1.5rem;
  }

  &__head {
    color: #fff;
    margin: 0 0 3rem;
    text-align: center;

    @media (max-width: 767px) {
      margin-bottom: 2rem;
    }
  }

  &__list {
    margin: 0;
    padding: 0;
  }

  &__item {
    list-style: none;
    color: #fff;
    font-size: 2rem;
    font-family: 'roboto-medium';
    line-height: 1.55;
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__number,
  &__answer {
    width: 8.5rem;
    flex-shrink: 0;

    @media (min-width: 1280px) {
      width: 6.5rem;
    }
  }

  &__name {
    flex: 1;
    text-align: center;
  }

  &__answer {
    text-align: right;
  }
}
</style>
